import { Userpilot } from 'userpilot';

let initialized = false;

function handleCreatedAt(createdAt: any) {
  /**
   * Handles createdAt timestamp formatting for Userpilot
   * - Userpilot expects a string, not a Firebase object
   * - createdAt seems to have been in various formats
   * - duplicated in bulk_identify.cjs
   * @param createdAt - Firebase timestamp, number, or null
   * @returns ISO string date or null
   */

  if (!createdAt) {
    return null;
  }

  if (typeof createdAt.toDate === 'function') {
    return createdAt.toDate().toISOString();
  }

  if (typeof createdAt === 'number') {
    return new Date(createdAt).toISOString();
  }

  if (typeof createdAt === 'object' && typeof createdAt.seconds === 'number') {
    // Convert seconds to milliseconds
    return new Date(createdAt.seconds * 1000).toISOString();
  }

  return null;
}

export function initUserpilot(token: string) {
  if (initialized) return;
  Userpilot.initialize(token);
  initialized = true;
}

export function identifyUser({currentUser, profile}) {
  if (!initialized) return;
  Userpilot.identify(currentUser.uid, {
    name: profile?.first_name + ' ' + profile?.last_name,
    email: currentUser.email,
    company: profile?.company_name,
    companySize: profile?.company_size,
    country: profile?.country,
    industry: profile?.industry,
    occupation: profile?.occupation,
    specialization: profile?.specialization,
    userRole: currentUser?.role,
    created_at: handleCreatedAt(profile?.created_at),
  });
}

export interface EventProperties {
  [key: string]: string | number | boolean | null | undefined;
}

export function trackEvent(event: string, properties?: EventProperties) {
  if (!initialized) return;
  Userpilot.track(event, properties);
}

export function disableUserpilot() {
  if (!initialized) return;
  // Clear Userpilot instance manually
  (window as any).userpilot = undefined;
  initialized = false;
}
